/* eslint-disable filename-rules/match */
import { createI18n } from "vue-i18n";
import countries from "i18n-iso-countries";

// Import i18n-iso-countries locales statically (only the ones we need)
import countriesLt from "i18n-iso-countries/langs/lt.json";
import countriesLv from "i18n-iso-countries/langs/lv.json";
import countriesRu from "i18n-iso-countries/langs/ru.json";
import countriesEn from "i18n-iso-countries/langs/en.json";
import countriesEt from "i18n-iso-countries/langs/et.json";
import countriesPl from "i18n-iso-countries/langs/pl.json";

// Map of country locale data
const countryLocales: Record<string, object> = {
  lt: countriesLt,
  lv: countriesLv,
  ru: countriesRu,
  en: countriesEn,
  et: countriesEt,
  pl: countriesPl,
};

// Use Vite's import.meta.glob for dynamic locale loading
const localeModules = import.meta.glob<{ default: Record<string, string> }>(
  "../../lang/ui/*.json",
  { eager: true }
);

function loadLocaleMessages() {
  const messages: Record<string, Record<string, string>> = {};

  for (const [path, module] of Object.entries(localeModules)) {
    // Extract locale from path (e.g., "../../lang/ui/lt.json" -> "lt")
    const matched = path.match(/\/([A-Za-z0-9-_]+)\.json$/i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = module.default || module;

      // Register country locale if available
      if (countryLocales[locale]) {
        countries.registerLocale(countryLocales[locale]);
      }
    }
  }

  return messages;
}

const locale = document.documentElement.lang;

const i18n = createI18n({
  locale,
  fallbackLocale: "lt",
  messages: loadLocaleMessages(),
});

export default i18n;
